import type { IJobEmployee, IAppUser } from '@/interfaces'
import AppUser from '@/models/AppUser'

class JobEmployee implements IJobEmployee {
  employeeId: string
  employee: IAppUser
  order: number

  constructor(jobEmployee?: any) {
    this.employeeId = jobEmployee?.employeeId
    this.employee = new AppUser(jobEmployee?.employee)
    this.order = jobEmployee?.order ?? 0
  }
}

export default JobEmployee
